module.exports = __webpack_public_path__ + "img/rocketman-green.50fd7a6c.svg";